// Copyright 2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import { apiGatewayClient } from './api'

export const STATUS_OPTIONS = [
  { key: 'approve', value: 'approve', text: 'Approve' },
  { key: 'decline', value: 'decline', text: 'Decline' },
  { key: 'in-force', value: 'in-force', text: 'In Force' }
]

export const PRODUCT_OPTIONS = [
  { key: 'proposal', value: 'proposal', text: 'Proposal Submission' },
  { key: 'lixi', value: 'lixi', text: 'LIXI Proposal Submission' }
]

export function requestPolicyStateChange({ product, proposalId, action, statusToken, apiKey, reporter }) {
  return apiGatewayClient()
    .then(client => client.post('/policy-state-change', {}, {
      product,
      proposalId,
      action,
      statusToken,
      apiKey,
      reporter
    }, {}))
    .then(({ data }) => data)
}
